import { useEffect, useRef } from 'react';
import { Animated, StyleSheet, View } from 'react-native';

import { useTheme } from './theme';

// 3-2-1-GO intro before a hold timer starts counting (Antenore 2026-06-05) —
// "come i veri timer". A big number fills the centre of the screen, pops in +
// fades, then the next one, then GO! and the count begins. Driven by
// useHoldTimer.intro (3 | 2 | 1 | 0=GO | null). pointerEvents none so it never
// blocks a tap; it's on screen for ~2.5s total then clears itself.
export function HoldCountdownOverlay({ intro }: { intro: number | null }) {
  const theme = useTheme();
  const scale = useRef(new Animated.Value(0.5)).current;
  const opacity = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    if (intro === null) return;
    scale.setValue(0.5);
    opacity.setValue(0);
    Animated.parallel([
      Animated.timing(opacity, {
        toValue: 1,
        duration: 160,
        useNativeDriver: true,
      }),
      Animated.spring(scale, {
        toValue: 1,
        friction: 5,
        tension: 80,
        useNativeDriver: true,
      }),
    ]).start(() => {
      Animated.timing(opacity, {
        toValue: 0,
        duration: 340,
        delay: 180,
        useNativeDriver: true,
      }).start();
    });
  }, [intro, scale, opacity]);

  if (intro === null) return null;
  const isGo = intro === 0;
  return (
    <View pointerEvents="none" style={styles.overlay}>
      <Animated.Text
        style={[
          styles.num,
          {
            color: isGo ? theme.palette.brand500 : theme.palette.ink,
            opacity,
            transform: [{ scale }],
          },
        ]}
      >
        {isGo ? 'GO!' : String(intro)}
      </Animated.Text>
    </View>
  );
}

const styles = StyleSheet.create({
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  num: {
    fontSize: 160,
    fontWeight: '900',
    fontVariant: ['tabular-nums'],
    textShadowColor: 'rgba(0,0,0,0.25)',
    textShadowOffset: { width: 0, height: 2 },
    textShadowRadius: 8,
  },
});
